import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class WorkflowRuleType extends Enum {
  key!: string;
  value!: string;

  static PRODUCT: WorkflowRuleType = {
    key: 'product',
    get value() {
      return Lang.t('asset.product');
    }
  };

  static JURISDICTION: WorkflowRuleType = {
    key: 'jurisdiction',
    get value() {
      return Lang.t('estate.jurisdiction');
    }
  };

  static BILLING_PLAN: WorkflowRuleType = {
    key: 'billing_plan',
    get value() {
      return Lang.t('estate.billing-plan');
    }
  };

  static PAYMENT_STATUS: WorkflowRuleType = {
    key: 'payment_status',
    get value() {
      return Lang.t('estate.payment-status');
    }
  };
}
